import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useHistory } from "react-router-dom";
import { auth } from "../../Authentication/firebase/firebase";
import API_Root from "../../Constants/API_Root";
import { doSignOut } from "../../Authentication/firebase/auth";
import { toggleToast } from "../../Actions/ToggleToast";
import { useDispatch } from "react-redux";
import {authFetch} from "../../Authentication/authService";

const SIDEBAR_WIDTH = 250;

function ProfileSection() {
  const dispatch = useDispatch();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const [hoveredItem, setHoveredItem] = useState(null);
  const history = useHistory();
  const [userEmail, setUserEmail] = useState("");
  const [userId, setUserId] = useState("")

  const [fullname, setFullName] = useState("");
  const [website, setWebsite] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");

  const [practitioner, setPractitioner] = useState(false);
  const [disclosures, setDisclosures] = useState(false);

  const [product, setProduct] = useState(false);
  const [training, setTraining] = useState(false);
  const [community, setCommunity] = useState(false);

  const [twoWays, setTwoWays] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // ---------------------------------------------------------
  // Fetch User Profile Data
  // ---------------------------------------------------------
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserEmail(user.email);
        fetchProfileInformation(user.email);
      } else {
        setUserEmail("");
      }
    });

    return () => unsubscribe();
  }, []);

  const fetchProfileInformation = (email) => {
    authFetch(API_Root + "users/get-user-details", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data) {
          setFullName(data.data.full_name);
          setUserId(data.data.id);
          setWebsite(data.data.company_website);
          setEmail(data.data.work_email);
          setRole(data.data.role);
          setCity(data.data.city);
          setCountry(data.data.country);
          setPractitioner(data.data.practitioner_opted);
          setDisclosures(data.data.newsletter_opted);
          setProduct(data.data.product_updates);
          setTraining(data.data.training_remainders);
          setCommunity(data.data.community_messages);
          setTwoWays(data.data.send_2fa);
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  // Resize Listener
  useEffect(() => {
    const resize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  // ---------------------------------------------------------
  // Input Handlers
  // ---------------------------------------------------------
  const handleFullName = (e) => setFullName(e.target.value);
  const handleWebsite = (e) => setWebsite(e.target.value);
  const handleEmail = (e) => setEmail(e.target.value);
  const handleRole = (e) => setRole(e.target.value);
  const handleCity = (e) => setCity(e.target.value);
  const handleCountry = (e) => setCountry(e.target.value);


  const handleNewPassword = (e) => setNewPassword(e.target.value);
  const handleConfirmPassword = (e) => setConfirmPassword(e.target.value);

  const handleTwoWays = () => setTwoWays(!twoWays);

  const handleProduct = () => setProduct(!product);
  const handleTraining = () => setTraining(!training);
  const handleCommunity = () => setCommunity(!community);

   // -------------------------------
  // SAVE CHANGES API
  // -------------------------------
  const handleSave = () => {
    if (newPassword !== confirmPassword) {
      alert("New password and confirm password do not match.");
      return;
    }

    const payload = {
      user_id: userId,
      full_name: fullname,
      company_website: website,
      work_email: email,
      role: role,
      city: city,
      country: country,
      send_2fa: twoWays ? true : false,
      product_updates: product ? true : false,
      training_remainders: training ? true : false,
      community_messages: community ? true : false,
    
      // Add passwords only if both exist
      ...(confirmPassword && newPassword && {
        current_password: confirmPassword,
        new_password: newPassword,
      }),
    };
    
    
    authFetch(API_Root + "users/update-account-setting", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("UPDATE RESPONSE:", data);
        alert("Profile updated successfully!");
      })
      .catch(() => {
        alert("Error updating profile.");
      });
  };

    const handlePractitioner = () => {
  const updatedValue = !practitioner;
  setPractitioner(updatedValue);

  const payload = {
    user_id: userId,
    full_name: fullname,
    company_website: website,
    work_email: email,
    role: role,
    city: city,
    country: country,
    practitioner_opted: updatedValue ? "True" : "False",
    newsletter_opted: disclosures ? "True" : "False", // keep existing
  };

  authFetch(API_Root + "subscription/update-publication-details", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => console.log("Practitioner Updated:", data));
};

const handleLogout = () => {
  doSignOut()
    .then(() => {
      localStorage.removeItem("isLoggedIn");
      history.push("/");
    })
    .catch(() => {
      dispatch(
        toggleToast({
          show: true,
          type: "error",
          message: "Logout failed",
        })
      );
    });
};

const handleDisclosures = () => {
  const updatedValue = !disclosures;
  setDisclosures(updatedValue);

  const payload = {
    user_id: userId,
    full_name: fullname,
    company_website: website,
    work_email: email,
    role: role,
    city: city,
    country: country,
    practitioner_opted: practitioner ? "True" : "False",
    newsletter_opted: updatedValue ? "True" : "False",
  };

  authFetch(API_Root + "subscription/update-publication-details", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => console.log("Newsletter Updated:", data));
};


  // ---------------------------------------------------------
  // Styling
  // ---------------------------------------------------------
  const containerStyle = {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    marginTop: "20px",
  };

  const labelStyle = {
    fontWeight: "500",
    marginBottom: "5px",
  };

  const sidebarStyle = {
    width: SIDEBAR_WIDTH,
    minHeight: "100vh",
    backgroundColor: "#f8f9fa",
    borderRight: "1px solid #e0e0e0",
    padding: "20px",
    position: isDesktop ? "relative" : "fixed",
    top: 0,
    left: isDesktop ? 0 : sidebarOpen ? 0 : -SIDEBAR_WIDTH,
    transition: "left 0.3s ease",
    zIndex: 1000,
  };

  const contentStyle = {
    // marginLeft: isDesktop ? SIDEBAR_WIDTH : 0,
    width: "100%",
    transition: "margin-left 0.3s ease",
  };

  const overlayStyle = {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.3)",
    display: !isDesktop && sidebarOpen ? "block" : "none",
    zIndex: 999,
  };

  const navItemStyle = {
    padding: "10px 15px",
    borderRadius: "6px",
    cursor: "pointer",
    marginBottom: "5px",
  };

  const activeNavItemStyle = {
    ...navItemStyle,
    backgroundColor: "#000",
    color: "#fff",
  };

  const getHoverStyle = (item) => ({
    ...navItemStyle,
    backgroundColor: hoveredItem === item ? "#e6e6e6" : "transparent",
  });

  // Navigation
  const ProductPage = () => history.push("/myproduct");
  const ActivityPage = () => history.push("/activity");
  const ShopPage = () => history.push("/shops");
  const SuportPage = () => history.push("/support");
    const TrainingPage = () => {
    history.push("/training")
  }

  const handleRedirection = () => history.push("/trainings")

  // ---------------------------------------------------------
  return (
    <div className="container-fluid p-0">
    <div style={overlayStyle} onClick={() => setSidebarOpen(false)} />

    <div className="d-flex">
        {/* Sidebar */}
        <div style={sidebarStyle}>
          <h5 className="fw-bold mb-4 d-flex justify-content-between align-items-center">
            E&S Solutions
            {!isDesktop && (
              <i
                className="bi bi-x-lg d-md-none"
                style={{ cursor: "pointer" }}
                onClick={() => setSidebarOpen(false)}
              ></i>
            )}
          </h5>

          {/* NAVIGATION ITEMS */}

          <div
            style={getHoverStyle("My Products")}
            onMouseEnter={() => setHoveredItem("My Products")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={ProductPage}
          >
            My Products
          </div>

          <div
            style={getHoverStyle("Shop / Marketplace")}
            onMouseEnter={() => setHoveredItem("Shop / Marketplace")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={ShopPage}
          >
            Shop / Marketplace
          </div>

          <div
            style={getHoverStyle("E&S Solutions Training Centre")}
            onMouseEnter={() => setHoveredItem("E&S Solutions Training Centre")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={TrainingPage}
          >
            E&S Solutions Training Centre
          </div>

          <div
            style={getHoverStyle("Support & Help")}
            onMouseEnter={() => setHoveredItem("Support & Help")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={SuportPage}
          >
            Support & Help
          </div>

          <div style={activeNavItemStyle}>Account Settings</div>

          {/* <div
            style={getHoverStyle("Community & Resources")}
            onMouseEnter={() => setHoveredItem("Community & Resources")}
            onMouseLeave={() => setHoveredItem(null)}
          >
            Community & Resources
          </div> */}

          <div
            style={getHoverStyle("Activity Log")}
            onMouseEnter={() => setHoveredItem("Activity Log")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={ActivityPage}
          >
            Activity Log
          </div>
        </div>

        {/* Main Content */}
        <div style={contentStyle}>
          {/* Top Bar */}
          <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
            {!isDesktop && (
              <i
                className="bi bi-list fs-3"
                style={{ cursor: "pointer" }}
                onClick={() => setSidebarOpen(true)}
              ></i>
            )}
            <h4 className="fw-bold m-0">Account Settings</h4>
            <div>
            <button
            className="me-2"
            onClick={handleLogout}
            style={{
              border: "1px solid black",
              backgroundColor: "transparent",
              cursor: "pointer",
              padding: '5px',
              transition: "all 0.3s ease",
              fontSize: "small",
            }}
          >
            Logout
          </button>
              <i className="bi bi-bell me-3"></i>
              <img
                src="https://alpha.essolutions.ai/static/media/newlogo.b86cf5045d46267faf39.png"
                alt="Profile"
                width={"20px"}
                className="rounded-circle"
              />
            </div>
          </div>

          {/* Actual Form */}
          <div className="p-4" style={{ maxWidth: "100%", overflowX: "hidden" }}>
            <div style={containerStyle}>
              <div className="row">
                {/* Left Column - Profile */}
                <div className="col-md-6 border-end">
                  <h6 className="fw-bold mb-3">Your Profile</h6>
                  <p className="text-muted small mb-4">
                    Update your basic information to personalize your experience.
                  </p>

                  {/* FULL NAME */}
                  <div className="mb-3">
                    <label style={labelStyle}>Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={fullname}
                      onChange={handleFullName}
                    />
                  </div>

                  {/* Website */}
                  <div className="mb-3">
                    <label style={labelStyle}>Company Website</label>
                    <input
                      type="text"
                      className="form-control"
                      value={website}
                      onChange={handleWebsite}
                    />
                  </div>

                  {/* Email */}
                  <div className="mb-3">
                    <label style={labelStyle}>Email</label>
                    <input
                      type="text"
                      className="form-control"
                      value={email}
                      onChange={handleEmail}
                    />
                  </div>

                  {/* Role */}
                  <div className="mb-3">
                    <label style={labelStyle}>Role</label>
                    <input
                      type="text"
                      className="form-control"
                      value={role}
                      onChange={handleRole}
                    />
                  </div>

                  {/* City */}
                  <div className="mb-3">
                    <label style={labelStyle}>City</label>
                    <input
                      type="text"
                      className="form-control"
                      value={city}
                      onChange={handleCity}
                    />
                  </div>

                  {/* Country */}
                  <div className="mb-3">
                    <label style={labelStyle}>Country</label>
                    <input
                      type="text"
                      className="form-control"
                      value={country}
                      onChange={handleCountry}
                    />
                  </div>

                  <div className="d-flex justify-content-end gap-2">
                    {/* <button className="btn btn-outline-secondary">Cancel</button> */}
                    <button className="btn btn-dark" onClick={handleRedirection}>Buy training Course</button>
                  </div>

                  {/* NEWSLETTERS */}
                  <h6 className="fw-bold mt-4 mb-3">Newsletters</h6>
                  <p className="text-muted small">
                    Stay updated with insights and disclosure reports.
                  </p>

                  <div className="form-check form-switch mb-2">
                    <label className="form-check-label" htmlFor="practitioner">
                      <span className="text-muted pr-2">Subscribe</span>
                      The E&S Practitioner
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="practitioner"
                      checked={practitioner}
                      onChange={handlePractitioner}
                    />
                  </div>

                  <div className="form-check form-switch">
                    <label className="form-check-label" htmlFor="disclosures">
                      <span className="text-muted pr-2">Subscribe</span>{" "}
                      Bi-weekly IFI Disclosures{" "}
                    </label>

                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="disclosures"
                      checked={disclosures}
                      onChange={handleDisclosures}
                    />
                  </div>
                </div>

                {/* Right Column - Security */}
                <div className="col-md-6 mt-5 mt-md-0">
                  <h6 className="fw-bold mb-3">Login & Security</h6>
                  <p className="text-muted small mb-4">
                    Protect your account and manage how you sign in.
                  </p>

                  {/* New Password */}
                  <div className="mb-3 position-relative">
                    <label style={labelStyle}>New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={newPassword}
                      onChange={handleNewPassword}
                    />
                    <i
                      className="bi bi-eye position-absolute"
                      style={{ right: "10px", top: "38px", cursor: "pointer" }}
                    ></i>
                  </div>

                  {/* Confirm Password */}
                  <div className="mb-4 position-relative">
                    <label style={labelStyle}>Confirm New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={confirmPassword}
                      onChange={handleConfirmPassword}
                    />
                    <i
                      className="bi bi-eye position-absolute"
                      style={{ right: "10px", top: "38px", cursor: "pointer" }}
                    ></i>
                  </div>

                  {/* 2FA */}
                  <div className="d-flex align-items-center mb-4">
                    <span style={labelStyle}>
                      Two-Factor Authentication (2FA)
                    </span>
                    <div className="form-check form-switch ms-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="2fa"
                        checked={twoWays}
                        onChange={handleTwoWays}
                      />
                    </div>
                  </div>

                  {/* Linked Accounts */}
                  <div className="mb-4">
                    <label style={labelStyle}>Linked Accounts</label>
                    <div>
                      <i className="bi bi-google me-3 fs-4 text-danger"></i>
                      <i className="bi bi-linkedin fs-4 text-primary"></i>
                    </div>
                  </div>

                  <h6 className="fw-bold mb-3">Notification Preferences</h6>
                  <p className="text-muted small">
                    Choose what you want to hear from us about.
                  </p>

                  {/* PRODUCT UPDATES */}
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="productUpdates"
                      checked={product}
                      onChange={handleProduct}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="productUpdates"
                    >
                      Product updates
                    </label>
                    <p className="text-muted small ms-4">
                      Be notified of new features and improvements.
                    </p>
                  </div>

                  {/* TRAINING REMINDERS */}
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="trainingReminders"
                      checked={training}
                      onChange={handleTraining}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="trainingReminders"
                    >
                      Training reminders
                    </label>
                    <p className="text-muted small ms-4">
                      Get nudges when new modules are available.
                    </p>
                  </div>

                  {/* COMMUNITY MESSAGES */}
                  <div className="form-check mb-4">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="communityMessages"
                      checked={community}
                      onChange={handleCommunity}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="communityMessages"
                    >
                      Community messages
                    </label>
                    <p className="text-muted small ms-4">
                      Receive updates from the E&S professional network.
                    </p>
                  </div>

                  <div className="d-flex justify-content-end gap-2">
                    <button className="btn btn-outline-secondary">Cancel</button>
                    <button className="btn btn-dark" onClick={handleSave}>Save Changes</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
}

export default ProfileSection;
